var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$props.itemDetail.componentSubcode === "dD_2"
      ? _c("div", [
          _c(
            "div",
            {
              style: {
                background: _vm.dataDisplay.backgroundColor,
                padding: "30px 10px 10px 10px",
                position: "relative",
                borderRadius: "10px 10px 0 0",
              },
            },
            [
              _vm.dataDisplay.levelUpEntry === 1
                ? _c("div", { staticClass: "tips-box" }, [
                    _c("div", { staticClass: "triangle-right" }),
                    _vm._v(" "),
                    _c("img", {
                      staticStyle: {
                        width: "100%",
                        height: "100%",
                        display: "block",
                      },
                      attrs: {
                        src: _vm.dataDisplay.levelUpPic
                          ? _vm.dataDisplay.levelUpPic
                          : require("@/assets/sj2.png"),
                      },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "h-bor",
                      style: {
                        width: "49%",
                        borderRadius: "8px",
                        background: "rgba(255,255,255,0.05)",
                        padding: "7px",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                            "font-size": "10px",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              style: { color: _vm.dataDisplay.titleTextColor },
                            },
                            [_vm._v("\n              已结算收益\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "btn",
                              style: {
                                color: _vm.dataDisplay.withdrawTextColor,
                                background:
                                  _vm.dataDisplay.withdrawBackgroundColor,
                              },
                            },
                            [_vm._v("\n              收益明细\n            ")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          style: {
                            fontWeight: "bold",
                            marginTop: "5px",
                            fontSize: "12px",
                            color: _vm.dataDisplay.dataShowTextColor,
                          },
                        },
                        [_vm._v("99999")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "h-bor",
                      style: {
                        width: "49%",
                        borderRadius: "8px",
                        background: "rgba(255,255,255,0.05)",
                        padding: "7px",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                            "font-size": "10px",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              style: { color: _vm.dataDisplay.titleTextColor },
                            },
                            [_vm._v("\n              账户余额\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "btn",
                              style: {
                                color: _vm.dataDisplay.withdrawTextColor,
                                background:
                                  _vm.dataDisplay.withdrawBackgroundColor,
                              },
                            },
                            [_vm._v("\n              去提现\n            ")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          style: {
                            fontWeight: "bold",
                            marginTop: "5px",
                            fontSize: "12px",
                            color: _vm.dataDisplay.dataShowTextColor,
                          },
                        },
                        [_vm._v("99999")]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                    "margin-top": "10px",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "10px",
                        "text-align": "center",
                      },
                    },
                    [
                      _c(
                        "div",
                        { style: { color: _vm.dataDisplay.titleTextColor } },
                        [_vm._v("今日预估")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          style: {
                            fontWeight: "bold",
                            fontSize: "12px",
                            marginTop: "5px",
                            color: _vm.dataDisplay.dataShowTextColor,
                          },
                        },
                        [_vm._v("999")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "10px",
                        "text-align": "center",
                      },
                    },
                    [
                      _c(
                        "div",
                        { style: { color: _vm.dataDisplay.titleTextColor } },
                        [_vm._v("本月预估")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          style: {
                            fontWeight: "bold",
                            fontSize: "12px",
                            marginTop: "5px",
                            color: _vm.dataDisplay.dataShowTextColor,
                          },
                        },
                        [_vm._v("999")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "10px",
                        "text-align": "center",
                      },
                    },
                    [
                      _c(
                        "div",
                        { style: { color: _vm.dataDisplay.titleTextColor } },
                        [_vm._v("本月收货")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          style: {
                            fontWeight: "bold",
                            fontSize: "12px",
                            marginTop: "5px",
                            color: _vm.dataDisplay.dataShowTextColor,
                          },
                        },
                        [_vm._v("999")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "10px",
                        "text-align": "center",
                      },
                    },
                    [
                      _c(
                        "div",
                        { style: { color: _vm.dataDisplay.titleTextColor } },
                        [_vm._v("待结收益")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          style: {
                            fontWeight: "bold",
                            fontSize: "12px",
                            marginTop: "5px",
                            color: _vm.dataDisplay.dataShowTextColor,
                          },
                        },
                        [_vm._v("999")]
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              style: {
                borderRadius: "0 0 10px 10px",
                fontSize: "10px",
                textAlign: "center",
                background: _vm.dataDisplay.remarkBackgroundColor,
                padding: "8px 0",
                color: _vm.dataDisplay.remarkTextColor,
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.dataDisplay.remark) + "\n    ")]
          ),
        ])
      : _vm.$props.itemDetail.componentSubcode === "dD_1"
      ? _c("div", [
          _c(
            "div",
            {
              style: {
                background: _vm.dataDisplay.backgroundColor,
                padding: "10px",
                position: "relative",
                borderRadius: "10px",
              },
            },
            [
              _c(
                "div",
                {
                  style: {
                    marginBottom: "8px",
                    color: _vm.dataDisplay.titleTextColor,
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticStyle: {
                        "font-size": "13px",
                        "font-weight": "500",
                      },
                    },
                    [_vm._v("账户总览")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      style: {
                        fontSize: "10px",
                        marginLeft: "8px",
                        color: _vm.dataDisplay.remarkTextColor,
                      },
                    },
                    [_vm._v(_vm._s(_vm.dataDisplay.remark))]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "h-bor",
                      style: {
                        width: "49%",
                        borderRadius: "8px",
                        background: "rgba(255,255,255,0.05)",
                        padding: "7px",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                            "font-size": "10px",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              style: { color: _vm.dataDisplay.titleTextColor },
                            },
                            [_vm._v("\n              已结算收益\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "btn",
                              style: {
                                color: _vm.dataDisplay.withdrawTextColor,
                                background:
                                  _vm.dataDisplay.withdrawBackgroundColor,
                              },
                            },
                            [_vm._v("\n              收益明细\n            ")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          style: {
                            fontWeight: "bold",
                            marginTop: "5px",
                            fontSize: "12px",
                            color: _vm.dataDisplay.dataShowTextColor,
                          },
                        },
                        [_vm._v("99999")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "h-bor",
                      style: {
                        width: "49%",
                        borderRadius: "8px",
                        background: "rgba(255,255,255,0.05)",
                        padding: "7px",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                            "font-size": "10px",
                            "align-items": "center",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              style: { color: _vm.dataDisplay.titleTextColor },
                            },
                            [_vm._v("\n              账户余额\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "btn",
                              style: {
                                color: _vm.dataDisplay.withdrawTextColor,
                                background:
                                  _vm.dataDisplay.withdrawBackgroundColor,
                              },
                            },
                            [_vm._v("\n              去提现\n            ")]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          style: {
                            fontWeight: "bold",
                            marginTop: "5px",
                            fontSize: "12px",
                            color: _vm.dataDisplay.dataShowTextColor,
                          },
                        },
                        [_vm._v("99999")]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                    "margin-top": "10px",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "10px",
                        "text-align": "center",
                      },
                    },
                    [
                      _c(
                        "div",
                        { style: { color: _vm.dataDisplay.titleTextColor } },
                        [_vm._v("今日预估")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          style: {
                            fontWeight: "bold",
                            fontSize: "12px",
                            marginTop: "5px",
                            color: _vm.dataDisplay.dataShowTextColor,
                          },
                        },
                        [_vm._v("999")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "10px",
                        "text-align": "center",
                      },
                    },
                    [
                      _c(
                        "div",
                        { style: { color: _vm.dataDisplay.titleTextColor } },
                        [_vm._v("本月预估")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          style: {
                            fontWeight: "bold",
                            fontSize: "12px",
                            marginTop: "5px",
                            color: _vm.dataDisplay.dataShowTextColor,
                          },
                        },
                        [_vm._v("999")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "10px",
                        "text-align": "center",
                      },
                    },
                    [
                      _c(
                        "div",
                        { style: { color: _vm.dataDisplay.titleTextColor } },
                        [_vm._v("本月收货")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          style: {
                            fontWeight: "bold",
                            fontSize: "12px",
                            marginTop: "5px",
                            color: _vm.dataDisplay.dataShowTextColor,
                          },
                        },
                        [_vm._v("999")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "10px",
                        "text-align": "center",
                      },
                    },
                    [
                      _c(
                        "div",
                        { style: { color: _vm.dataDisplay.titleTextColor } },
                        [_vm._v("待结收益")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          style: {
                            fontWeight: "bold",
                            fontSize: "12px",
                            marginTop: "5px",
                            color: _vm.dataDisplay.dataShowTextColor,
                          },
                        },
                        [_vm._v("999")]
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.dataDisplay.levelUpEntry === 1
                ? _c("div", { staticStyle: { "margin-top": "8px" } }, [
                    _c("img", {
                      staticStyle: {
                        width: "100%",
                        height: "35px",
                        display: "block",
                      },
                      attrs: {
                        src: _vm.dataDisplay.levelUpPic
                          ? _vm.dataDisplay.levelUpPic
                          : require("@/assets/sj1.png"),
                      },
                    }),
                  ])
                : _vm._e(),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }